import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

function SBSNotificationSnackbar() {
  const [notification, setNotification] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleStatusUpdate = (event) => {
      /**
       * Handles SBS status update events to show notifications
       * @param {CustomEvent} event - The event containing status update details
       */
      const {
        executionId, clientId, status, data,
      } = event.detail;

      // Only show notification if user is not already on the SBS page for this client
      const isOnSBSPage = location.pathname.includes(`/client/${clientId}/Strategy/Multi-Channel/SBS`);
      if (!isOnSBSPage && (status === 'Success' || status === 'Failed')) {
        let message;
        let severity;

        if (status === 'Success') {
          message = `✅ Sum by Source report completed for ${clientId}`;
          severity = 'success';
        } else {
          message = `❌ Sum by Source report failed for ${clientId}`;
          severity = 'error';
        }

        setNotification({
          message,
          severity,
          clientId,
          executionId,
          data,
        });
        setOpen(true);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('sbsStatusUpdate', handleStatusUpdate);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('sbsStatusUpdate', handleStatusUpdate);
      }
    };
  }, [location]);

  const handleClose = (event, reason) => {
    /**
     * Handles closing of the notification snackbar
     * @param {object} event - The event object
     * @param {string} reason - The reason for closing
     */
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleViewReport = () => {
    /**
     * Navigates to the SBS report page for the notification's client
     */
    if (notification) {
      navigate(`/client/${notification.clientId}/Strategy/Multi-Channel/SBS/Download?tab=1`);
      setOpen(false);
    }
  };

  if (!notification) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={15000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.severity}
        variant="filled"
        action={(
          <Button
            color="inherit"
            size="small"
            onClick={handleViewReport}
            sx={{ ml: 1 }}
          >
            View Report
          </Button>
        )}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}

export default SBSNotificationSnackbar;
